export default {
    "scale-in": {
        origin: { scale: 0.8 },
        destination: { scale: 1 },
    },
    "scale-in-fade-in": {
        origin: { scale: 0.8, opacity: 0 },
        destination: { scale: 1, opacity: 1 },
    },
    "scale-out": {
        origin: { scale: 1.2 },
        destination: { scale: 1 },
    },
    "scale-out-fade-in": {
        origin: { scale: 1.2, opacity: 0 },
        destination: { scale: 1, opacity: 1 },
    },
    "scale-out-blur-in": {
        origin: { scale: 1.2, opacity: 0, filter: "blur(12px)" },
        destination: { scale: 1, opacity: 1, filter: "blur(0px)" },
    },
    "scale-out-grayscale-in": {
        origin: { scale: 1.2, filter: "grayscale(100%)" },
        destination: { scale: 1, filter: "grayscale(0%)" },
    },
};
